export const theme = 'sportscraft';

export const specificSlidesOffsetAfter = {};
